import { Budget } from '@/types/budget';

export default function useCost() {
  const defaultCostType: Budget[] = [
    // {
    //   lock: true, category: 'STD', name: 'ME', cost: '',
    // },
    {
      lock: true, category: 'STD', name: 'EE', cost: '',
    },
    {
      lock: true, category: 'STD', name: 'SCREW', cost: '',
    },
    {
      lock: true, category: 'CTT', name: 'Sub Contact', cost: '',
    },
    {
      lock: true, category: 'FAB', name: 'FAB', cost: '',
    },
    {
      lock: true, category: 'ค่าแรง', name: 'ค่าแรง Assembly', cost: '',
    },
    {
      lock: true, category: 'ค่าแรง', name: 'ค่าแรง Wing', cost: '',
    },
    {
      lock: true, category: 'ค่าแรง', name: 'ค่าแรง Design ME', cost: '',
    },
    {
      lock: true, category: 'ค่าแรง', name: 'ค่าแรง Design EE', cost: '',
    },
    {
      lock: true, category: 'ค่าแรง', name: 'ค่าแรง Program', cost: '',
    },
    {
      lock: true, category: 'ค่าแรง', name: 'ค่าแรง ADJ', cost: '',
    },
    {
      lock: true, category: 'SRV', name: 'ค่า After Service', cost: '',
    },
    {
      lock: true, category: 'SRV', name: 'ค่า Documentation', cost: '',
    },
    {
      lock: true, category: 'SRV', name: 'ค่า Packaging และจัดส่ง', cost: '',
    },
    {
      lock: true, category: 'SRV', name: 'ค่า Set Up & Install', cost: '',
    },
  ];

  return {
    defaultCostType,
  };
}
